import React from 'react';
import { PERMISSIONS_KEY, ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import InflowTable from '../../../../payments/modules/endUser/components/InflowTable';
import EndUsersTabs from '../components/EndUsersTabs';
import AccessControl from '../../../../../AccessControl';
import NewOrderTable from '../../../../orders/modules/combined-orders/components/NewOrderTable';

const Orders = ({ match: { params: { id, userNumber } = {} } = {} }) => (
  <>
    <Portal portalId="header-title-content">
      <GoBackButton
        customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
      />
      <div className="portal-header">View End User</div>
    </Portal>
    <EndUsersTabs endUserId={id} endUserNumber={userNumber} isView>
      <div className="tab-table">
        <AccessControl permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS}>
          <NewOrderTable userId={id} isSystemUsersTab />
        </AccessControl>
      </div>
    </EndUsersTabs>
  </>
);

export default Orders;
